import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {roomRunFileSelector} from '../../../../../store/selectors/roomRunFile.selectors';
import QuestionReportModal from './QuestionReportModal';
import {fetchQuestionReportAction} from '../../../../../store/actions/analytics.actions';
import Button from '../../../../../incase-domain/components/button/Button';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';

interface IUserAnsweredCountProps {
    element: IElementQuestionnaire;
}

function DisplayLiveResults(props: IUserAnsweredCountProps): JSX.Element {
    const {element} = props;
    const {t} = useTranslation();

    const dispatch = useDispatch();

    const roomRunFile = useSelector(roomRunFileSelector);

    const [isStatisticsModalOpen, setIsStatisticsModalOpen] = useState<boolean>(false);

    const openStatisticsModal = (): void => {
        dispatch(fetchQuestionReportAction(element.id, roomRunFile._id));
        setIsStatisticsModalOpen(true);
    };

    return (
        <>
            <Button
                variant="outline"
                type="button"
                onClick={openStatisticsModal}
                color="info"
                className="c-questionLayout__showResultsButton"
            >
                <span>{t('report.results')}</span>
            </Button>
            {isStatisticsModalOpen && (
                <QuestionReportModal open={isStatisticsModalOpen} setOpen={setIsStatisticsModalOpen} element={element} />
            )}
        </>
    );
}

export default DisplayLiveResults;
